
import HeavenItem from './HeavenItem';
import { ANGELS } from '../../../helpers/ConfigScene';
import HiAngelPart from './HiAngelPart';
import AngelSnowParticle from './AngelSnowParticle';
import { EVENTS } from '../../../../shared/Events';

class HiAngel extends HeavenItem {
  constructor(parentCont, data) {
    super(data);
    // const
    this.SNOW_CEIL = aPage.features.isCanvas ? 750 : 1500;
    this.SNOW_MAX = aPage.features.isCanvas ? 500 : 1000;
    this.SNOW_MIN = aPage.features.isCanvas ? 50 : 100;

    this.SNOW_DIFF = this.SNOW_MAX - this.SNOW_MIN;

    this.DELAY_MAX = aPage.features.isCanvas ? 400 : 200;
    this.DELAY_MIN = aPage.features.isCanvas ? 50 : 25;
    this.DELAY_DIFF = this.DELAY_MAX - this.DELAY_MIN;

    // vars snow
    this.flakeLast = 0;
    this.flakeDelay = 0;
    this.flakesActive = [];
    this.flakesPool = [];

    // vars
    this.parentCont = parentCont;
    this.angelId = Number(this.data.type.split('_')[0].replace('a', ''));
    this.angelData = ANGELS[`a${this.angelId}`];
    this.angelParts = [];
    this.flakes = [];

    // animation
    this.frameActual = 0;
    this.frameTotal = this.angelData.anim[this.angelData.parts[0].replace('.png', '')].length;
    this.animTimer = null;
    this.ANIM_STEP = 41.667;

    // parts
    this.mainCont = null;
    this.snow = null;
    this.angel = null;

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  init() {
    // vars
    aScene.sceneManager.snowAngels.push(0);

    // parts
    this.mainCont = new PIXI.Container();
    this.parentCont.addChild(this.mainCont);
    this.setSnow();
    this.setAngel();

    // signals
    aScene.signals.sceneCallMain.add(this.callMainFc, this);
  }

  // --------------------------------------------------------------
  // Main Call
  // --------------------------------------------------------------

  callMainFc(sgType) {
    switch (sgType) {
      case EVENTS.MOVE_TO_HEAVEN_START:
        // reset flakes + value to average
        aScene.sceneManager.snowAngels[this.angelId] = aScene.sceneManager.snowMain;
        this.resetFlakes();
        break;
      default:
    }
  }

  // --------------------------------------------------------------
  // Snow
  // --------------------------------------------------------------

  setSnow() {
    // set container
    this.snow = new PIXI.ParticleContainer(this.SNOW_CEIL, {
      scale: true,
      position: true,
      rotation: false,
      uvs: false,
      alpha: true,
    });
    this.snow.x = this.angelData.snow.x;
    this.snow.y = this.angelData.snow.y;
    this.mainCont.addChildAt(this.snow, 0);
  }

  addFlake(randomY) {
    let flake = null;
    if (this.flakesPool.length > 0) {
      flake = this.flakesPool.pop();
    } else {
      flake = new AngelSnowParticle(
        this.snow,
        this.angelData.snow.w,
      );
    }
    flake.reset(randomY);
    this.flakesActive.push(flake);
  }

  resetFlakes() {
    // reset current
    this.flakesActive.forEach((flake) => {
      flake.remove();
      this.flakesPool.push(flake);
    });
    this.flakesActive = [];
    // set
    for (
      let i = 0;
      i < Math.round(this.SNOW_MIN +
        (this.SNOW_DIFF * aScene.sceneManager.snowAngels[this.angelId]));
      i += 1) {
      this.addFlake(true);
    }
  }

  flakesWave() {
    const angelValue = aScene.sceneManager.snowAngels[this.angelId];
    if (angelValue < 1) {
      aScene.sceneManager.snowAngels[this.angelId] = Math.min(angelValue + 0.5, 1);
      const waveLimit = aPage.features.isCanvas ? 40 : 80;
      for (let i = 0; i < waveLimit; i += 1) {
        this.addFlake(false);
      }
    }
    aScene.sceneManager.snowUpdate();
  }

  moveFlakes() {
    const movingFlakes = [];
    this.flakesActive.forEach((flake) => {
      if (flake.lUp()) {
        movingFlakes.push(flake);
      } else {
        this.flakesPool.push(flake);
      }
    });
    this.flakesActive = movingFlakes;
  }

  addFlakes() {
    this.flakeLast += aScene.sceneManager.msFrame;
    this.flakeDelay = this.DELAY_MAX -
      (this.DELAY_DIFF * aScene.sceneManager.snowAngels[this.angelId]);
    while (this.flakeLast > this.flakeDelay) {
      this.flakeLast -= this.flakeDelay;
      this.addFlake(false);
    }
  }

  // --------------------------------------------------------------
  // Angel parts
  // --------------------------------------------------------------

  setAngel() {
    this.angel = new PIXI.Container();
    this.mainCont.addChild(this.angel);
    for (let i = 0; i < this.angelData.parts.length; i += 1) {
      const partId = this.angelData.parts[i];
      this.angelParts.push(new HiAngelPart(this.angel, partId, this.angelData.anim[partId.replace('.png', '')]));
    }

    // interactivity
    this.angel.interactive = true;
    this.angel.buttonMode = true;
    this.angel.on('pointerdown', () => {
      this.playAnim();
    });
  }

  playAnim() {
    if (this.frameActual === 0) {
      this.animTimer = setInterval(() => {
        this.animStep();
      }, this.ANIM_STEP);
      aScene.sndManager.playSfx(`angels/a-${this.angelId}`);
      setTimeout(() => {
        this.flakesWave();
      }, this.angelData.snow.delay);
    }
  }

  animStep() {
    this.frameActual += 1;
    if (this.frameActual === this.frameTotal) {
      // end
      clearInterval(this.animTimer);
      this.frameActual = 0;
    }
    this.animUpdate();
  }

  animUpdate() {
    this.angelParts.forEach((part) => {
      part.setFrame(this.frameActual);
    });
  }

  // --------------------------------------------------------------
  // Loop
  // --------------------------------------------------------------

  loopUp() {
    super.loopUp();
    this.mainCont.x = this.position.item.x;
    this.mainCont.y = this.position.item.y;
    // snow
    this.moveFlakes();
    this.addFlakes();
  }
}

export default HiAngel;



// WEBPACK FOOTER //
// ./src/js/scene/parts/heaven/parts/HiAngel.js